/* Opuloral homepage: product tab filters and quick add to bag.
   Quick add uses the same cart drawer refresh as the theme's product form. */
(function () {
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-opu-tab]');
    if (tab) {
      var root = tab.closest('[data-opu-grid]');
      var keys = (tab.getAttribute('data-opu-tab') || '').toLowerCase().split(',').map(function (k) { return k.trim(); }).filter(Boolean);
      root.querySelectorAll('[data-opu-tab]').forEach(function (b) { b.setAttribute('aria-pressed', b === tab ? 'true' : 'false'); });
      // A tab with its own panel shows that panel; otherwise filter the main grid by keyword.
      var panelId = tab.getAttribute('data-opu-panel-id') || '';
      root.querySelectorAll('[data-opu-panel]').forEach(function (panel) {
        var id = panel.getAttribute('data-opu-panel');
        panel.hidden = panelId ? id !== panelId : id !== '';
      });
      var main = root.querySelector('[data-opu-panel=""]');
      (main || root).querySelectorAll('[data-opu-type]').forEach(function (card) {
        var type = card.getAttribute('data-opu-type');
        card.hidden = !panelId && keys.length > 0 && !keys.some(function (k) { return type.indexOf(k) !== -1; });
      });
      return;
    }

    var add = event.target.closest('[data-opu-add]');
    if (!add) return;
    event.preventDefault();
    if (add.disabled) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var label = add.textContent;
    var body = new FormData();
    body.append('id', add.getAttribute('data-opu-add'));
    body.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    add.disabled = true;
    add.textContent = add.getAttribute('data-opu-adding') || 'Adding';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          add.textContent = response.description || response.message || label;
          setTimeout(function () { add.textContent = label; add.disabled = false; }, 2500);
          return;
        }
        add.textContent = label;
        add.disabled = false;
        if (cart && cart.renderContents) {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        add.textContent = label;
        add.disabled = false;
        window.location = window.routes.cart_url;
      });
  });
})();
